import toast from 'react-hot-toast';
import Icon from "@material-tailwind/react/Icon";
import Swal from "sweetalert2";
import Select from "react-select";
import { useState, useEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
import { checkUser } from "helpers/Session";
import API from "../helpers/api";
// import API2 from "../helpers/api";
import { optimizeImageUrl } from "../helpers/imageOptimization";

const MAX_PHOTO_SIZE = 5 * 1024 * 1024;

export const buildUserUpdateFormData = ({
  nama,
  jabatan,
  kementerian,
  idProker,
  foto,
}) => {
  const data = new FormData();
  data.append("nama", nama);
  data.append("id_jabatan", jabatan);
  data.append("id_kementerian", kementerian);
  data.append("id_proker", idProker.join(","));
  if (foto) {
    data.append("foto", foto);
  }
  return data;
};

const User = () => {
  const [user, setUser] = useState([]);
  const [dummy, setDummy] = useState([]);
  const [nim, setNim] = useState("");
  const [nama, setNama] = useState("");
  const [kementerian, setKementerian] = useState(0);
  const [jabatan, setJabatan] = useState(0);
  const [proker, setProker] = useState([]);
  const [foto, setFoto] = useState("");
  const [id, setId] = useState(0);
  const [allKementerian, setAllKementerian] = useState([]);
  const [allJabatan, setAllJabatan] = useState([]);
  const [selectedProker, setSelectedProker] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadUser, setLoadUser] = useState(true);
  const [valid, setValid] = useState(false);
  const [loadingProker, setLoadingProker] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [message, setMessage] = useState("");
  const inputRef = useRef(null);

  const addUser = async () => {
    if (loading) return;
    setLoading(true);
    const id_proker = proker.map((item) => item.id_proker);

    try {
      const data = new FormData();
      data.append("nim", nim);
      data.append("nama", nama);
      data.append("id_jabatan", jabatan);
      data.append("id_kementerian", kementerian);
      data.append("id_proker", JSON.stringify(id_proker));
      data.append("foto", foto);
      const response = await API.post("/users", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {
        toast.success("Data berhasil ditambahkan");
        setLoadUser(true);
        setShowAddModal(false);
      } else {
        toast.error("Data gagal ditambahkan");
      }
    } catch (error) {
      
    } finally {
      setLoading(false);
    }
  };
  const editUser = async () => {
    if (loading) return;
    setLoading(true);
    const id_proker = proker.map((item) => item.id_proker);
    try {
      const response = foto
        ? await API.put(
            `/users/${id}`,
            buildUserUpdateFormData({
              nama,
              jabatan,
              kementerian,
              idProker: id_proker,
              foto,
            }),
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            },
          )
        : await API.put(`/users/${id}`, {
            nama: nama,
            id_jabatan: jabatan,
            id_kementerian: kementerian,
            id_proker: id_proker,
          });
      if (response.status === 200) {
        toast.success("Data berhasil diubah");
        setLoadUser(true);
        setShowEditModal(false);
      } else {
        toast.error("Data gagal diubah");
      }
    } catch (error) {
      
    } finally {
      setLoading(false);
    }
  };

  const deleteUser = (id) => {
    Swal.fire({
      title: "Apakah kamu yakin?",
      text: "Kamu akan menghapus data dengan NIM " + id + "!",
      icon: "warning",
      showCancelButton: true,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return API.delete(`/users/${id}`)
          .then((response) => {
            if (response.status === 200) {
              return response.data;
            } else {
              throw new Error(response.data);
            }
          })
          .catch((error) => {
            toast.error("Data gagal dihapus");
            throw error; // Propagate the error further
          });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    })
      .then((res) => {
        if (res.isConfirmed) {
          toast.success("Data berhasil dihapus");
          setLoadUser(true);
        }
      })
      .catch((error) => {
        Swal.fire("Error", "Terjadi kesalahan: " + error.message, "error");
      });
  };

  const resetForm = () => {
    setNim("");
    setNama("");
    setKementerian(0);
    setJabatan(0);
    setProker([]);
    setFoto("");
    setId(0);
    setSelectedProker([]);
    setValid(false);
    setMessage("");
    if (inputRef.current) {
      inputRef.current.value = null;
    }
  };

  const closeModal = () => {
    setShowAddModal(false);
    setShowEditModal(false);
    resetForm();
  };

  const isBPI = () => {
    return Number(kementerian) === 12;
  };

  useEffect(() => {
    let pass = true;
    const isNim = new RegExp("^[0-9]{15}$");

    if (nim === "" || nama === "" || kementerian === 0 || jabatan === 0) {
      pass = false;
    }

    if (!isNim.test(nim)) {
      pass = false;
    }

    if (pass) {
      setValid(true);
      setMessage("✅ Periksa kembali sebelum submit!");
    } else {
      setValid(false);
      setMessage("❌ Periksa format pengisian!");
    }
  }, [valid, nim, nama, kementerian, jabatan, proker]);

  useEffect(() => {
    if (!showAddModal && !showEditModal) {
      resetForm();
    }
  }, [showAddModal, showEditModal]);

  useEffect(() => {
    if (!loadUser) return;
    (async () => {
      await API.get("/users")
        .then((res) => {
          const userData = Array.isArray(res.data.data) ? res.data.data : [];
          setUser(userData);
          setDummy(userData);
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Terjadi kesalahan",
            text: "Silahkan hubungi PIT!",
            footer: "Error: " + err.message,
          });
        })
        .finally(() => {
          setLoadUser(false);
        });
    })();
  }, [loadUser]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [kementerianRes, jabatanRes] = await Promise.all([
          API.get("/kementerian"),
          API.get("/jabatan"),
        ]);

        setAllKementerian(
          Array.isArray(kementerianRes.data.data) ? kementerianRes.data.data : [],
        );
        setAllJabatan(
          Array.isArray(jabatanRes.data.data) ? jabatanRes.data.data : [],
        );
      } catch (_error) {
        toast.error("Data referensi gagal dimuat");
      }
    };

    fetchData();
  }, []);

  const setDataUpdate = (item) => {
    setId(item.nim);
    setNim(item.nim);
    setNama(item.nama || "");
    setKementerian(item.kementerian?.id_kementerian || 0);
    setJabatan(item.jabatan?.id_jabatan || 0);
    setProker(Array.isArray(item.proker) ? item.proker : []);
    setFoto("");
    setShowEditModal(true);
  };

  useEffect(() => {
    if (Number(kementerian) === 0) return;
    if (Number(kementerian) === 12) {
      setJabatan(4);
      return null;
    }
    const fetchProker = async () => {
      try {
        setLoadingProker(true);
        const response = await API.get(`/kementerian/${kementerian}/proker`);
        const prokerData = response.data.data;
        setSelectedProker(Array.isArray(prokerData) ? prokerData : []);
      } catch (_error) {
        toast.error("Data proker gagal dimuat");
      } finally {
        setLoadingProker(false);
      }
    };
    fetchProker();
  }, [kementerian]);

  const search = (params) => {
    if (params === "") {
      setUser(dummy);
    } else {
      let result = dummy.filter(
        (item) =>
          (item.nama || "").toLowerCase().includes(params.toLowerCase()) ||
          (item.kementerian?.singkatan || "")
            .toLowerCase()
            .includes(params.toLowerCase()) ||
          (item.jabatan?.jabatan || "").toLowerCase().includes(params.toLowerCase())
      );
      setUser(result);
    }
  };

  return (
    <>
      {!checkUser() ? (
        <Redirect to={"/"} />
      ) : (
        <>
          <div className="bg-primary-light px-3 md:px-8 h-40" />

          <div className="px-3 md:px-8 h-auto -mt-36">
            <div className="container mx-auto max-w-full min-h-screen">
              <div className="grid grid-cols-1 px-4 mb-16">
                <div className="flex w-full justify-between my-4">
                  <div className="self-center">
                    <button className="bg-success text-white px-4 py-2 rounded-xl flex items-center gap-2 hover:bg-success/90 transition shadow-sm" onClick={(e) => setShowAddModal(true)}>
                      <Icon name="add" size="xl" /> Tambah Anggota
                    </button>
                  </div>
                  <div className="self-center">
                    <div className="pt-2 relative mx-auto text-text-body">
                      <input
                        className="bg-white h-10 px-5 pr-16 rounded-lg text-sm focus:outline-none"
                        type="text"
                        name="search"
                        placeholder="Cari Sesuatu..."
                        onChange={(e) => search(e.target.value)}
                      />
                      <button
                        type="submit"
                        className="absolute right-0 top-0 mt-5 mr-4"
                        disabled
                      >
                        <Icon name="search" size="xl" />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="glass-card flex flex-col min-w-0 break-words bg-white w-full shadow-soft rounded-2xl">
                  <div className="p-6">
                    <div className="overflow-x-auto overflow-y-auto max-h-screen">
                      <table className="relative items-center w-full border-collapse">
                        <thead>
                          <tr className="bg-gradient-to-r from-primary to-primary-light">
                            <th className="sticky top-0 z-10 bg-primary px-3 text-white align-middle py-4 text-xs uppercase tracking-wider font-semibold text-left rounded-tl-lg">
                              Foto
                            </th>
                            <th className="sticky top-0 z-10 bg-primary px-3 text-white align-middle py-4 text-xs uppercase tracking-wider font-semibold text-left">
                              NIM
                            </th>
                            <th className="sticky top-0 z-10 bg-primary px-3 text-white align-middle py-4 text-xs uppercase tracking-wider font-semibold text-left">
                              Nama
                            </th>
                            <th className="sticky top-0 z-10 bg-primary px-3 text-white align-middle py-4 text-xs uppercase tracking-wider font-semibold text-left">
                              Kementerian
                            </th>
                            <th className="sticky top-0 z-10 bg-primary px-3 text-white align-middle py-4 text-xs uppercase tracking-wider font-semibold text-left">
                              Jabatan
                            </th>
                            <th className="sticky top-0 z-10 bg-primary px-3 text-white align-middle py-4 text-xs uppercase tracking-wider font-semibold text-left">
                              Proker
                            </th>
                            <th className="sticky top-0 z-10 bg-primary px-3 text-white align-middle py-4 text-xs uppercase tracking-wider font-semibold text-center rounded-tr-lg">
                              Aksi
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {!loadUser ? (
                            user.length > 0 ? (
                              user.map((item, index) => {
                                const itemProker = Array.isArray(item.proker)
                                  ? item.proker
                                  : [];
                                const hasPhoto =
                                  item.foto !== null &&
                                  item.foto !== "" &&
                                  item.foto !== "-";
                                return (
                                  <tr
                                    key={index}
                                    className="hover:bg-background transition-colors duration-150"
                                  >
                                    {/* Foto */}
                                    <td className="border-b border-gray-200 align-middle px-3 py-3">
                                      <div className="w-12 h-12 rounded-full overflow-hidden bg-gradient-to-br from-primary-light to-primary flex items-center justify-center shadow-sm flex-shrink-0 relative">
                                        {hasPhoto ? (
                                          <img
                                            className="w-12 h-12 object-cover"
                                            src={optimizeImageUrl(item.foto, 100)}
                                            alt={item.nama || "Foto anggota"}
                                          />
                                        ) : (
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="h-6 w-6 text-white opacity-80"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                          >
                                            <path
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              strokeWidth={1.5}
                                              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                            />
                                          </svg>
                                        )}
                                      </div>
                                    </td>
                                    {/* NIM */}
                                    <td className="border-b border-gray-200 align-middle font-normal text-sm whitespace-nowrap px-3 py-4 text-left text-text-body">
                                      {item.nim}
                                    </td>
                                    {/* Nama */}
                                    <td className="border-b border-gray-200 align-middle font-medium text-sm px-3 py-4 text-left capitalize text-text-heading">
                                      {(item.nama || "-").toLowerCase()}
                                    </td>
                                    {/* Kementerian */}
                                    <td className="border-b border-gray-200 align-middle text-sm whitespace-nowrap px-3 py-4 text-left">
                                      <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-info bg-opacity-20 text-primary">
                                        {item.kementerian?.singkatan || "-"}
                                      </span>
                                    </td>
                                    {/* Jabatan */}
                                    <td className="border-b border-gray-200 align-middle text-sm whitespace-nowrap px-3 py-4 text-left text-text-body">
                                      {item.jabatan?.jabatan || "-"}
                                    </td>
                                    {/* Proker */}
                                    <td className="border-b border-gray-200 align-middle text-sm px-3 py-4 text-left">
                                      <div className="break-word w-44 overflow-y-auto text-text-body">
                                        {itemProker.length > 0 ? (
                                          <ul className="list-inside list-disc space-y-0.5">
                                            {itemProker.map((prokerItem, i) => {
                                              return (
                                                <li key={i} className="text-xs">
                                                  {prokerItem.proker || "-"}
                                                </li>
                                              );
                                            })}
                                          </ul>
                                        ) : (
                                          <p className="text-text-muted">-</p>
                                        )}
                                      </div>
                                    </td>
                                    {/* Aksi */}
                                    <td className="border-b border-gray-200 align-middle text-sm whitespace-nowrap px-3 py-4">
                                      <div className="flex justify-center gap-2">
                                        <button className="bg-warning/10 text-warning p-2 rounded-lg hover:bg-warning hover:text-white transition shadow-sm group" onClick={(e) => { setDataUpdate(item); }}>
                                          <Icon name="edit" size="xl" />
                                        </button>
                                        <button className="bg-danger/10 text-danger p-2 rounded-lg hover:bg-danger hover:text-white transition shadow-sm group" onClick={(e) => { deleteUser(item.nim); }}>
                                          <Icon name="delete" size="xl" />
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td
                                  colSpan={7}
                                  className="border-b border-gray-200 align-middle text-sm px-3 py-12 text-center text-text-muted"
                                >
                                  <div className="flex flex-col items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                    <span>Belum ada data anggota</span>
                                  </div>
                                </td>
                              </tr>
                            )
                          ) : (
                            <>
                              {[1, 2, 3, 4, 5].map((i) => (
                                <tr key={i}>
                                  <td className="border-b border-gray-200 px-3 py-3">
                                    <div className="w-12 h-12 rounded-full bg-gray-200 animate-pulse"></div>
                                  </td>
                                  <td className="border-b border-gray-200 px-3 py-4">
                                    <div className="h-4 w-28 bg-gray-200 rounded animate-pulse"></div>
                                  </td>
                                  <td className="border-b border-gray-200 px-3 py-4">
                                    <div className="h-4 w-32 bg-gray-200 rounded animate-pulse"></div>
                                  </td>
                                  <td className="border-b border-gray-200 px-3 py-4">
                                    <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
                                  </td>
                                  <td className="border-b border-gray-200 px-3 py-4">
                                    <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
                                  </td>
                                  <td className="border-b border-gray-200 px-3 py-4">
                                    <div className="h-4 w-28 bg-gray-200 rounded animate-pulse"></div>
                                  </td>
                                  <td className="border-b border-gray-200 px-3 py-4">
                                    <div className="h-8 w-20 mx-auto bg-gray-200 rounded animate-pulse"></div>
                                  </td>
                                </tr>
                              ))}
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Modal for add user */}
          {showAddModal && (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none bg-text-heading/50 backdrop-blur-sm transition-all">
      <div className="relative w-full max-w-lg mx-auto my-6">
        <div className="border-0 rounded-2xl shadow-xl relative flex flex-col w-full bg-white outline-none focus:outline-none">
          <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t-2xl">
            <h3 className="text-xl font-bold text-text-heading">Tambah Anggota</h3>
            <button className="p-1 ml-auto bg-transparent border-0 text-text-muted float-right text-3xl leading-none font-semibold outline-none focus:outline-none hover:text-danger" onClick={() => closeModal()}>×</button>
          </div>
          <div className="relative p-6 flex-auto">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  addUser();
                }}
              >
                <div className="flex flex-wrap">
                  <div className="w-full mb-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Foto (Max. 5 MB)
                    </label>
                    <input
                      className="w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-primary focus:ring-2 focus:ring-primary/50"
                      type="file"
                      placeholder="Masukkan Foto..."
                      accept="image/*"
                      ref={inputRef}
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        if (file && file.size > MAX_PHOTO_SIZE) {
                          toast.error("Ukuran foto maksimal 5 MB");
                          e.target.value = null;
                          setFoto("");
                          return;
                        }
                        setFoto(file || "");
                      }}
                      required
                    />
                  </div>
                  <div className="w-full mb-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      NIM
                    </label>
                    <input
                      className="w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-primary focus:ring-2 focus:ring-primary/50"
                      type="text"
                      placeholder="Masukkan NIM..."
                      value={nim}
                      onChange={(e) => {
                        setNim(e.target.value);
                      }}
                      required
                    />
                  </div>
                  <div className="w-full mb-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Nama
                    </label>
                    <input
                      className="w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-primary focus:ring-2 focus:ring-primary/50"
                      type="text"
                      placeholder="Masukkan Nama..."
                      value={nama}
                      onChange={(e) => {
                        setNama(e.target.value);
                      }}
                      required
                    />
                  </div>
                  <div className="w-full mb-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Kementerian
                    </label>
                    <select
                      className="w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-primary focus:ring-2 focus:ring-primary/50"
                      onChange={(e) => {
                        setKementerian(e.target.value);
                        setProker([]);
                      }}
                      value={kementerian}
                      required
                    >
                      <option value={0}>Pilih Kementerian</option>
                      {allKementerian.length > 0 &&
                        allKementerian.map((item, index) => {
                          return (
                            <option key={index} value={item.id_kementerian}>
                              {item.singkatan}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                  <div className="w-full mb-4">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Jabatan
                    </label>
                    <select
                      className="w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-primary focus:ring-2 focus:ring-primary/50"
                      onChange={(e) => {
                        setJabatan(e.target.value);
                      }}
                      value={jabatan}
                      required
                      disabled={isBPI()}
                    >
                      <option value={0}>Pilih Jabatan</option>
                      {allJabatan.length > 0 &&
                        allJabatan.map((item, index) => {
                          return (
                            <option key={index} value={item.id_jabatan}>
                              {item.jabatan}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                  <div className="w-full mb-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Proker
                    </label>
                    <Select menuPortalTarget={document.body} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      options={selectedProker}
                      onChange={(e) => {
                        setProker(e);
                      }}
                      cacheOptions
                      isMulti
                      value={proker}
                      getOptionLabel={(option) => option.proker}
                      getOptionValue={(option) => option.id_proker}
                      isDisabled={jabatan === 1 || loadingProker === true}
                      isLoading={loadingProker}
                      placeholder="Pilih Proker..."
                      defaultValue={"-"}
                    />
                  </div>
                  <div className="w-full flex justify-between items-center">
                    <button
                      type="submit"
                      className={
                        "text-white bg-primary focus:ring-4 focus:outline-none focus:ring-primary/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center disabled:opacity-30 disabled:pointer-events-none"
                      }
                      disabled={loading || !valid}
                    >
                      Submit
                    </button>
                    <p className="text-sm text-gray-700">{message}</p>
                  </div>
                </div>
              </form>
            </div>
        </div>
      </div>
    </div>
  )}

          {/* Modal for edit user */}
          {showEditModal && (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none bg-text-heading/50 backdrop-blur-sm transition-all">
      <div className="relative w-full max-w-lg mx-auto my-6">
        <div className="border-0 rounded-2xl shadow-xl relative flex flex-col w-full bg-white outline-none focus:outline-none">
          <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t-2xl">
            <h3 className="text-xl font-bold text-text-heading">Ubah Anggota</h3>
            <button className="p-1 ml-auto bg-transparent border-0 text-text-muted float-right text-3xl leading-none font-semibold outline-none focus:outline-none hover:text-danger" onClick={() => closeModal()}>×</button>
          </div>
          <div className="relative p-6 flex-auto">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  editUser();
                }}
              >
                <div className="flex flex-wrap">
                  <div className="w-full mb-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Ganti Foto (Opsional, Max. 5 MB)
                    </label>
                    <input
                      className="w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-primary focus:ring-2 focus:ring-primary/50"
                      type="file"
                      placeholder="Masukkan Foto..."
                      accept="image/*"
                      ref={inputRef}
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        if (file && file.size > MAX_PHOTO_SIZE) {
                          toast.error("Ukuran foto maksimal 5 MB");
                          e.target.value = null;
                          setFoto("");
                          return;
                        }
                        setFoto(file || "");
                      }}
                    />
                  </div>
                  <div className="w-full mb-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      NIM
                    </label>
                    <input
                      className="w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-primary focus:ring-2 focus:ring-primary/50"
                      type="text"
                      placeholder="Masukkan NIM..."
                      value={nim}
                      onChange={(e) => {
                        setNim(e.target.value);
                      }}
                      disabled
                      required
                    />
                  </div>
                  <div className="w-full mb-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Nama
                    </label>
                    <input
                      className="w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-primary focus:ring-2 focus:ring-primary/50 capitalize"
                      type="text"
                      placeholder="Masukkan Nama..."
                      value={nama}
                      onChange={(e) => {
                        setNama(e.target.value);
                      }}
                      required
                    />
                  </div>
                  <div className="w-full mb-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Kementerian
                    </label>
                    <select
                      className="w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-primary focus:ring-2 focus:ring-primary/50"
                      value={kementerian}
                      onChange={(e) => {
                        setKementerian(e.target.value);
                        setProker([]);
                      }}
                      required
                    >
                      <option value={0}>Pilih Kementerian</option>
                      {allKementerian ? (
                        allKementerian.map((item, index) => {
                          return (
                            <option key={index} value={item.id_kementerian}>
                              {item.singkatan}
                            </option>
                          );
                        })
                      ) : (
                        <></>
                      )}
                    </select>
                  </div>
                  <div className="w-full mb-4">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Jabatan
                    </label>
                    <select
                      className="w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-primary focus:ring-2 focus:ring-primary/50"
                      value={jabatan}
                      onChange={(e) => {
                        setJabatan(e.target.value);
                      }}
                      disabled={isBPI()}
                      required
                    >
                      <option value={0}>Pilih Jabatan</option>
                      {allJabatan ? (
                        allJabatan.map((item, index) => {
                          return (
                            <option key={index} value={item.id_jabatan}>
                              {item.jabatan}
                            </option>
                          );
                        })
                      ) : (
                        <></>
                      )}
                    </select>
                  </div>
                  <div className="w-full mb-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Proker
                    </label>
                    <Select menuPortalTarget={document.body} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      options={selectedProker}
                      onChange={(e) => {
                        setProker(e);
                      }}
                      cacheOptions
                      isMulti
                      value={proker}
                      getOptionLabel={(option) => option.proker}
                      getOptionValue={(option) => option.id_proker}
                      isDisabled={jabatan === 2 || loadingProker === true}
                      isLoading={loadingProker}
                      placeholder="Pilih Proker..."
                      defaultValue={"-"}
                    />
                  </div>
                  <div className="w-full flex justify-between items-center">
                    <button
                      type="submit"
                      className="text-white bg-primary focus:ring-4 focus:outline-none focus:ring-primary/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center disabled:opacity-30 disabled:pointer-events-none"
                      disabled={loading || !valid}
                    >
                      Submit
                    </button>
                    <p className="text-sm text-gray-700">{message}</p>
                  </div>
                </div>
              </form>
            </div>
        </div>
      </div>
    </div>
  )}
        </>
      )}
    </>
  );
};

export default User;
